"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { useStyles } from "./styles";
import Button from "@/components/common/PrimaryButton";
import RelatedGens from "@/components/gen/RelatedGens";

function cleanString(input: string): string {
  const withoutNumbers = input.replace(/-\d+$/, "");
  const cleanedString = withoutNumbers.replace(/-/g, " ");
  return cleanedString;
}

const GenPageContent = () => {
  const { classes } = useStyles();
  const pathname = usePathname();
  const slug = pathname?.split("/")?.[2] || "";
  const searchQuery = cleanString(slug);

  return (
    <div className={classes.container}>
      <div className={classes.notFoundContent}>
        <h1 className={classes.notFoundTitle}>Generation not found</h1>
        <p className={classes.notFoundText}>
          This generation either does not exist or has been removed.
        </p>
        <Link
          href={`/${
            searchQuery ? `?q=${encodeURIComponent(searchQuery)}` : ""
          }`}
        >
          <Button variant="outlined">View Feed</Button>
        </Link>
      </div>
      <div className={classes.notFoundExploreRelated}>
        <RelatedGens searchQuery={searchQuery} />
      </div>
    </div>
  );
};

export default GenPageContent;
